import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';
import Routes from '../../common/routes';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

type Props = {
  routes: Route[];
};

type Route = {
  path: string;
  breadcrumb: string;
};

const Breadcrumbs = ({ routes }: Props) => {
  const crumbs = useBreadcrumbs(routes);

  return (
    <nav className='flex' aria-label='Breadcrumb'>
      <ol className='inline-flex items-center'>
        {crumbs.map(({ match, breadcrumb }) => {
          return (
            <li key={match.url}>
              {match.url === '/' && (
                <Link
                  to={match.url}
                  className='flex flex-row items-center text-sm text-ptsgreen-dark hover:text-gray-600 hover:no-underline'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-4 w-4 mr-1 text-ptsgreen-dark'
                    viewBox='0 0 20 20'
                    fill='currentColor'
                  >
                    <path d='M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z' />
                  </svg>
                  {breadcrumb}
                </Link>
              )}

              {match.url !== '/' && (
                <div className='flex flex-row items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-4 w-4 mx-1'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M9 5l7 7-7 7'
                    />
                  </svg>
                  <Link
                    to={match.url}
                    className='flex flex-row items-center text-sm text-ptsgreen-dark hover:text-gray-600 hover:no-underline'
                  >
                    {breadcrumb}
                  </Link>
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

const Header = () => {
  const location = useLocation();

  const current = Routes.find((r) =>
    matchPath(location.pathname, {
      path: r.path,
      exact: true,
      strict: false,
    })
  );

  return (
    <div className='max-w-7xl mx-auto py-5 px-4 sm:px-6 lg:px-8'>
      <h1 className='text-3xl font-bold text-gray-900 mb-2'>
        {current?.title}
      </h1>
      <Breadcrumbs routes={Routes} />
    </div>
  );
};

export default Header;
